// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react';
import { Badge, Fab, Grow, IconButton, Zoom } from '@mui/material';
import { ArrowDownward, AttachFile, InsertEmoticon, Send } from '@mui/icons-material';
import SmsIcon from '@mui/icons-material/Sms';
import ImageIcon from '@mui/icons-material/Image';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import ContactsIcon from '@mui/icons-material/Contacts';
import NotesIcon from '@mui/icons-material/Notes';
import MicIcon from '@mui/icons-material/Mic';
import { Emoji, NimblePicker } from 'emoji-mart';
import styles from './ChatFooter.module.css';
import 'emoji-mart/css/emoji-mart.css';
import '../../styles/EmojiPicker.css';
import PubSub from 'pubsub-js';
import FileInput from '../FileInput';
import { translateHTMLInputToText } from '@src/helpers/Helpers';
import VoiceRecord from './VoiceRecord';
import {
	EMOJI_SET,
	EMOJI_SHEET_SIZE,
	EVENT_TOPIC_EMOJI_PICKER_VISIBILITY,
	EVENT_TOPIC_FOCUS_MESSAGE_INPUT,
	EVENT_TOPIC_REQUEST_MIC_PERMISSION,
} from '@src/Constants';
import ChatMessageModel from '../../api/models/ChatMessageModel';
import { replaceEmojis } from '@src/helpers/EmojiHelper';
import { useTranslation } from 'react-i18next';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import ContactsModal from '../ContactsModal';
import data from 'emoji-mart/data/facebook.json';
import QuickActionsMenu from '@src/components/QuickActionsMenu';
import KeyboardCommandKeyIcon from '@mui/icons-material/KeyboardCommandKey';
import classNames from 'classnames/bind';
import useChatFooter from '@src/components/ChatFooter/useChatFooter';
import styled from 'styled-components';
import { Cross, LockIconSmall, SendIcon } from '../Icons';
import { useAppSelector } from '@src/store/hooks';
import { ALL_PERMISSION_MAP, checkPermission } from '@src/helpers/Permission';
import usePermission from '@src/hooks/usePermission';
import CustomTooltip from '../CustomTootip/CustomTooltip';

const FeedbackField = styled.div`
	display: flex;
	flex-direction: column;
	height: 92px;
	border-radius: 4px;
	background-color: white;
	border-top: 8px solid #ffdf80;
	margin: 0 10px;
	h3 {
		color: #000;
		font-size: 14px;
		font-weight: 700;
		padding: 5px 10px;
	}
`;

const cx = classNames.bind(styles);

const ChatFooter: React.FC = ({
	waId,
	currentNewMessages,
	isExpired,
	input,
	setInput,
	sendMessage,
	sendFeedback,
	bulkSendMessage,
	setSelectedFiles,
	isTemplateMessagesVisible,
	setTemplateMessagesVisible,
	accept,
	isSavedResponsesVisible,
	setSavedResponsesVisible,
	sendHandledChosenFiles,
	setAccept,
	isScrollButtonVisible,
	handleScrollButtonClick,
	processCommand,
	feeadbackField,
	setFieldBackField,
}) => {
	const { t } = useTranslation();

	//Permissions
	const checkPermission = usePermission();
	const sendMessagePermission = checkPermission(ALL_PERMISSION_MAP?.GENERAL?.MESSAGE?.SEND, waId);

	const fileInput = useRef(null);
	const editable = useRef(null);

	const [isAttachmentOptionsVisible, setAttachmentOptionsVisible] = useState(false);
	const [isEmojiPickerVisible, setEmojiPickerVisible] = useState(false);
	const [contactsModalVisible, setContactsModalVisible] = useState(false);
	const [isQuickActionsMenuVisible, setQuickActionsMenuVisible] = useState(false);

	const [isRecording, setRecording] = useState(false);

	const { insertAtCursor, handleCopy } = useChatFooter({ setInput });

	const handleAttachmentClick = (acceptValue) => {
		setAccept(acceptValue);

		fileInput.current.setAttribute('accept', acceptValue);
		fileInput.current.click();

		if (window.AndroidWebInterface) {
			window.AndroidWebInterface.requestPermissions();
		}
	};

	const handleEmojiPickerVisibility = function (msg, data) {
		setEmojiPickerVisible(data);
	};

	let timeout = useRef();
	const handleEditableChange = (event) => {
		if (timeout.current) {
			clearTimeout(timeout.current);
		}

		timeout.current = setTimeout(function () {
			setInput(event.target.innerHTML);
		}, 5);
	};

	useEffect(() => {
		const token = PubSub.subscribe(
			EVENT_TOPIC_EMOJI_PICKER_VISIBILITY,
			handleEmojiPickerVisibility
		);

		return () => {
			PubSub.unsubscribe(token);
		};
	}, []);

	// useEffect(() => {
	// 	// Workaround for focused input for expired chats
	// 	if (isExpired) {
	// 		editable.current?.blur();
	// 	}

	// 	// Focus on the message input when chat is loaded
	// 	const eventToken = PubSub.subscribe(EVENT_TOPIC_FOCUS_MESSAGE_INPUT, () => {
	// 		if (!isExpired) {
	// 			editable.current?.focus();
	// 		}
	// 	});

	// 	return () => {
	// 		PubSub.unsubscribe(eventToken);
	// 	};
	// }, [editable.current, isExpired]);

	useEffect(() => {
		editable?.current?.focus();
	}, [editable?.current, feeadbackField]);

	useEffect(() => {
		const preparedInput = translateHTMLInputToText(input).trim();
		if (preparedInput.startsWith('/')) {
			displayQuickActionsMenu();
		}
	}, [input]);

	useEffect(() => {
		// Clear editable div when message is sent
		if (input === '') {
			if (editable.current) {
				editable.current.innerHTML = '';
			}
		}
	}, [editable, input]);

	const toggleTemplateMessages = () => {
		// If messages container is already scrolled to bottom
		/*const elem = messagesContainer.current;
        const offset = 5;

        let willScroll = false;
        if (elem.offsetHeight + elem.scrollTop >= (elem.scrollHeight - offset)) {
            willScroll = true;
        }*/

		setTemplateMessagesVisible((prevState) => {
			if (!prevState) {
				setAttachmentOptionsVisible(false);
				setSavedResponsesVisible(false);
				setEmojiPickerVisible(false);
			}

			return !prevState;
		});
	};

	const toggleSavedResponses = () => {
		setSavedResponsesVisible((prevState) => {
			if (!prevState) {
				setAttachmentOptionsVisible(false);
				setTemplateMessagesVisible(false);
				setEmojiPickerVisible(false);
			}

			return !prevState;
		});
	};

	const toggleEmojiPicker = () => {
		setEmojiPickerVisible((prevState) => {
			if (!prevState) {
				setAttachmentOptionsVisible(false);
				setTemplateMessagesVisible(false);
				setSavedResponsesVisible(false);
			}

			return !prevState;
		});
	};

	const handleEmojiSelect = (emoji) => {
		if (isRecording) {
			return;
		}

		if (editable.current) {
			// TODO: Try to avoid creating an emoji object here, if possible
			const emojiOutput = Emoji({
				html: true,
				emoji: emoji.colons,
				size: 22,
				set: EMOJI_SET,
				sheetSize: EMOJI_SHEET_SIZE,
			});

			insertAtCursor(editable.current, emojiOutput);
		}
	};

	const handlePaste = (event) => {
		let text = (event.originalEvent || event).clipboardData.getData('text/plain');
		text = replaceEmojis(text, true);

		insertAtCursor(editable.current, text);

		event.preventDefault();
	};

	const displayQuickActionsMenu = () => {
		if (!isQuickActionsMenuVisible) {
			setQuickActionsMenuVisible(true);
			setTemplateMessagesVisible(false);
			setSavedResponsesVisible(false);
			setEmojiPickerVisible(false);
		}
	};

	const handleFocus = (event) => {
		if (isRecording) {
			event.target.blur();
		}
	};

	const handleMouseUp = (event) => {
		if (isExpired) {
			displayQuickActionsMenu();
		}
	};

	const hasInput = () => {
		return input && input.length > 0;
	};

	const openContactsModal = () => {
		setContactsModalVisible(true);
	};

	const closeContactsModal = () => {
		setContactsModalVisible(false);
	};

	// https://developers.facebook.com/docs/whatsapp/on-premises/reference/media#supported-files
	const ACCEPT_IMAGE_AND_VIDEO = 'image/jpeg, image/png, video/mp4, video/3gpp';
	const ACCEPT_DOCUMENT = '*.*';

	return (
		<div
			className={cx({
				chatFooterGlobal: true,
				container: true,
			})}
			onDrop={(event) => event.preventDefault()}
		>
			{isQuickActionsMenuVisible && (
				<QuickActionsMenu
					input={translateHTMLInputToText(input).trim()}
					setInput={setInput}
					setVisible={setQuickActionsMenuVisible}
					onProcessCommand={processCommand}
					isExpired={isExpired}
				/>
			)}

			{isEmojiPickerVisible && (
				<div className={styles.emojiPicker}>
					<NimblePicker
						set={EMOJI_SET}
						sheetSize={EMOJI_SHEET_SIZE}
						data={data}
						showPreview={false}
						emojiSize={32}
						onSelect={handleEmojiSelect}
					/>
				</div>
			)}

			<ContactsModal
				open={contactsModalVisible}
				onClose={closeContactsModal}
				sendMessage={(payload, onSuccess, onError) =>
					sendMessage(false, undefined, payload, onSuccess, onError)
				}
				recipientWaId={waId}
			/>
			{feeadbackField && sendMessagePermission ? (
				<FeedbackField>
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							letterSpacing: '0.20px',
						}}
					>
						<h3>{`Order #${feeadbackField?.timeId || feeadbackField?.orderId} Feedback`}</h3>
						<IconButton onClick={() => setFieldBackField(null)}>
							<Cross />
						</IconButton>
					</div>
					<div className={cx({ row: true, footer: true })}>
						<form>
							<div
								className={cx({
									typeBox: true,
									expired: isExpired,
								})}
							>
								{!input && (
									<div className={styles.typeBoxHint}>
										<span>{t('Type a message')}</span>
									</div>
								)}
								<div
									id="typeBox__editable"
									ref={editable}
									className={styles.typeBoxEditable}
									contentEditable="true"
									onFocus={handleFocus}
									onMouseUp={handleMouseUp}
									onPaste={(event) => handlePaste(event)}
									onCopy={(event) => handleCopy(event)}
									onDrop={(event) => event.preventDefault()}
									spellCheck="true"
									onInput={(event) => handleEditableChange(event)}
									onKeyDown={(e) => {
										if (e.keyCode === 13 && !e.shiftKey) sendFeedback(true, e);
									}}
								/>
							</div>
							<button onClick={(e) => sendFeedback(true, e)} type="submit">
								{t('Send a message')}
							</button>
						</form>
					</div>
				</FeedbackField>
			) : sendMessagePermission ? (
				<div className={cx({ row: true, footer: true })}>
					<form>
						<div
							className={cx({
								typeBox: true,
								expired: isExpired,
							})}
						>
							{!input && (
								<div className={styles.typeBoxHint}>
									{isExpired ? (
										<span>
											{t('This chat has expired. You need to answer with template messages.')}
										</span>
									) : (
										<span>{t('Type a message')}</span>
									)}
								</div>
							)}
							<div
								id="typeBox__editable"
								ref={editable}
								className={styles.typeBoxEditable}
								contentEditable="true"
								onFocus={handleFocus}
								onMouseUp={handleMouseUp}
								onPaste={(event) => handlePaste(event)}
								onCopy={(event) => handleCopy(event)}
								onDrop={(event) => event.preventDefault()}
								spellCheck="true"
								onInput={(event) => handleEditableChange(event)}
								onKeyDown={(e) => {
									if (e.keyCode === 13 && !e.shiftKey) sendMessage(true, e);
								}}
							/>
						</div>
						<button onClick={(e) => sendMessage(true, e)} type="submit">
							{t('Send a message')}
						</button>
					</form>
				</div>
			) : (
				<div className={cx({ row: true, footer: true })}>
					<div
						className={cx({
							typeBox: true,
							expired: isExpired,
						})}
					>
						<div className={styles.typeBoxHint}>
							<span style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
								<LockIconSmall stroke="#acacac" />
								<span>You do not have permission to send message.</span>
							</span>
						</div>

						<div
							style={{
								position: 'relative',
								'z-index': 100,
								width: '100%',
								'min-height': '36px',
								'max-height': '250px',
								'overflow-y': 'auto',
								'word-break': 'break-word',
								opacity: '0.5',
							}}
							contentEditable="false"
						/>
					</div>
				</div>
			)}

			<div
				className={cx({
					row: true,
					actionsRow: true,
				})}
			>
				<div
					className={cx({
						actionsRowLeft: true,
						desktopOnly: isRecording,
					})}
				>
					{/* <CustomTooltip title={t('Quick Actions')} placement="top">
						<IconButton
							className={cx({
								actionIcon: true,
								active: isQuickActionsMenuVisible,
								commandActionIcon: true,
							})}
							onClick={displayQuickActionsMenu}
							size="small"
						>
							<KeyboardCommandKeyIcon />
						</IconButton>
					</CustomTooltip> */}

					{/* <div
						className={cx({
							actionSeparator: true,
							desktopOnly: isAttachmentOptionsVisible,
						})}
					/> */}
					{/* 
					<CustomTooltip
						title="Templates"
						placement="top"
						className={cx({
							desktopOnly: isAttachmentOptionsVisible,
						})}
					>
						<IconButton
							data-test-id="templates-button"
							onClick={toggleTemplateMessages}
							className={cx({
								actionIcon: true,
								active: isTemplateMessagesVisible,
							})}
							size="small"
						>
							<SmsIcon />
						</IconButton>
					</CustomTooltip> */}

					{/* {!isExpired && (
						<CustomTooltip
							title="Saved Responses"
							placement="top"
							className={cx({
								desktopOnly: isAttachmentOptionsVisible,
							})}
						>
							<IconButton
								onClick={toggleSavedResponses}
								className={cx({
									actionIcon: true,
									active: isSavedResponsesVisible,
								})}
								size="small"
							>
								<NotesIcon />
							</IconButton>
						</CustomTooltip>
					)} */}

					{/* {!isExpired && <div className={styles.actionSeparator} />} */}

					{/* {!isExpired && (
						<CustomTooltip
							title={t('Emoji')}
							placement="top"
							className={cx({
								desktopOnly: isAttachmentOptionsVisible,
							})}
						>
							<IconButton
								className={cx({
									actionIcon: true,
									active: isEmojiPickerVisible,
								})}
								onClick={toggleEmojiPicker}
								size="small"
							>
								<InsertEmoticon />
							</IconButton>
						</CustomTooltip>
					)} */}

					{!isExpired && (
						<div
							className={cx({
								attachmentContainer: true,
								open: isAttachmentOptionsVisible,
							})}
						>
							{sendMessagePermission ? (
								<CustomTooltip title={t('Attachment')} placement="top">
									<IconButton
										className={cx({
											actionIcon: true,
											active: isAttachmentOptionsVisible,
										})}
										size="small"
										onClick={() => setAttachmentOptionsVisible(!isAttachmentOptionsVisible)}
									>
										<AttachFile />
									</IconButton>
								</CustomTooltip>
							) : (
								<CustomTooltip
									title="You do not have permission to send message. Contact 
							an administrator to get permission."
									placement="top"
								>
									<span>
										<IconButton
											className={cx({
												actionIcon: true,
												active: isAttachmentOptionsVisible,
											})}
											size="small"
											onClick={() => {}}
											disabled
										>
											<AttachFile />
										</IconButton>
									</span>
								</CustomTooltip>
							)}

							<Grow in={isAttachmentOptionsVisible} unmountOnExit>
								<div
									className={cx({
										attachmentOptions: true,
									})}
								>
									<CustomTooltip title={t('Images & Videos')} placement="top">
										<IconButton
											className={cx({
												actionIcon: true,
												attachmentOptionImageAndVideo: true,
											})}
											onClick={() => handleAttachmentClick(ACCEPT_IMAGE_AND_VIDEO)}
											size="small"
										>
											<ImageIcon />
										</IconButton>
									</CustomTooltip>

									<CustomTooltip title={t('Documents')} placement="top">
										<IconButton
											className={cx({
												actionIcon: true,
												attachmentOptionDocument: true,
											})}
											onClick={() => handleAttachmentClick(ACCEPT_DOCUMENT)}
											size="small"
										>
											<InsertDriveFileIcon />
										</IconButton>
									</CustomTooltip>

									{/* <CustomTooltip title={t('Contacts')} placement="top">
										<IconButton
											className={cx({
												actionIcon: true,
											})}
											onClick={openContactsModal}
											size="small"
										>
											<ContactsIcon />
										</IconButton>
									</CustomTooltip> */}
								</div>
							</Grow>
						</div>
					)}
				</div>

				<div className={styles.actionsRowRight}>
					<div
						className={cx({
							hidden: !isRecording,
						})}
					>
						<VoiceRecord
							voiceRecordCase="chat"
							setRecording={setRecording}
							sendHandledChosenFiles={sendHandledChosenFiles}
						/>
					</div>

					{/* {hasInput() && (
						<CustomTooltip title={t('Bulk Send')} placement="top">
							<IconButton
								className={styles.actionIcon}
								onClick={() => bulkSendMessage(ChatMessageModel.TYPE_TEXT)}
								size="small"
							>
								<DynamicFeedIcon />
							</IconButton>
						</CustomTooltip>
					)} */}

					{/* {!isExpired && !hasInput() && !isRecording && (
						<CustomTooltip title={t('Voice')} placement="top">
							<IconButton
								className={styles.actionIcon}
								onClick={() => PubSub.publish(EVENT_TOPIC_REQUEST_MIC_PERMISSION, 'chat')}
								size="small"
							>
								<MicIcon />
							</IconButton>
						</CustomTooltip>
					)} */}

					{hasInput() && (
						<CustomTooltip title={t('Send')} placement="top">
							<IconButton
								className={styles.actionIcon}
								onClick={
									feeadbackField ? (e) => sendFeedback(true, e) : (e) => sendMessage(true, e)
								}
								data-test-id="send-message-button"
								size="small"
							>
								<SendIcon />
							</IconButton>
						</CustomTooltip>
					)}
				</div>
			</div>

			<div className="hidden">
				<FileInput
					innerRef={fileInput}
					accept={accept}
					handleSelectedFiles={(files) => {
						if (accept !== ACCEPT_DOCUMENT && !ACCEPT_IMAGE_AND_VIDEO.includes(files[0].type)) {
							window.displayCustomError(
								t('Please choose a supported file type (png, jpg, mp4, 3gp)')
							);

							return;
						}

						setSelectedFiles({ ...files });
					}}
				/>
			</div>

			<Zoom in={isScrollButtonVisible}>
				<Badge
					className={styles.scrollButtonWrapper}
					color="primary"
					overlap="rectangular"
					badgeContent={currentNewMessages}
					invisible={currentNewMessages === 0}
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
					style={{ bottom: feeadbackField ? '138px' : '112px' }}
				>
					<Fab onClick={handleScrollButtonClick} className={styles.scrollButton} size="small">
						<ArrowDownward />
					</Fab>
				</Badge>
			</Zoom>
		</div>
	);
};

export default ChatFooter;
